var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "dialer-settings-main"
  }, [_c('div', {
    staticClass: "d-flex align-items-center mb-3 calc-title-widthIOS v2"
  }, [_c('div', {
    staticClass: "settingsTextAndIconOnTop",
    on: {
      "click": function ($event) {
        return _vm.$emit('back');
      }
    }
  }, [_c('vb-icon', {
    attrs: {
      "icon": "backToSettingsList-IOSIcon",
      "width": "11.434",
      "height": "20"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('back');
      }
    }
  }), _c('div', {
    staticClass: "settingsTextOnTop"
  }, [_vm._v("Settings")])], 1), _c('div', {
    staticClass: "dialer-settings-title topMainHeading"
  }, [_vm._v("Call Queue")]), _c('div', {
    staticClass: "plus-IOSIcon-container"
  }, [_c('vb-icon', {
    staticClass: "plus-IOSIcon",
    attrs: {
      "icon": "plus-IOSIcon",
      "width": "20",
      "height": "19.992"
    },
    on: {
      "click": function ($event) {
        _vm.checkPermission(_vm.getUserPermissions.call_queue, function () {
          return _vm.$modal.show('AddCallQueue', {
            suggested_name: `call queue ${_vm.getVoipCallQueues.length + 1}`
          });
        });
      }
    }
  })], 1)]), _c('section', {
    staticClass: "dialer-settings-section dialer-ivr-setting CallQueueSettings"
  }, [[_c('div', {
    staticClass: "mobileInputIOS iconOnLeft mt-32px"
  }, [_c('b-input', {
    attrs: {
      "type": "text",
      "placeholder": "Search numbers"
    },
    model: {
      value: _vm.filter.call_queues.search,
      callback: function ($$v) {
        _vm.$set(_vm.filter.call_queues, "search", $$v);
      },
      expression: "filter.call_queues.search"
    }
  }), _c('vb-icon', {
    staticClass: "mobileInputIOS-icon",
    attrs: {
      "width": "13.785",
      "height": "13.726",
      "icon": "Search-IOSIcon"
    }
  })], 1)], _c('div', {
    staticClass: "basicWhiteIOScard mt-32px mb-16px"
  }, _vm._l(_vm.filterCallQueue, function (callQueue) {
    return _c('div', {
      key: callQueue.voipaccount,
      staticClass: "basicWhiteIOScard-item",
      on: {
        "click": function ($event) {
          return _vm.$modal.show('EditCallQueueModal', {
            call_queue: callQueue
          });
        }
      }
    }, [_c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('div', {
      staticClass: "InfoComponentInsideAnroidIOSApp"
    }, [_c('vb-avatar', {
      attrs: {
        "id": callQueue.voipaccount
      }
    })], 1), _c('div', {
      staticClass: "d-flex flex-column"
    }, [[_c('div', {
      staticClass: "headingInsideTable"
    }, [_vm._v(" " + _vm._s(callQueue.label) + " ")])]], 2)]), _c('div', {
      staticClass: "d-flex align-items-center"
    }, [callQueue.userDid && callQueue.userDid[0] ? _c('div', {
      staticClass: "d-flex mr-6px flex-column"
    }, [callQueue.userDid.length == 1 ? _c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('div', {
      staticClass: "textInsideCard textAlignRight onRightSide"
    }, [_vm._v(" " + _vm._s(_vm._f("get_property")(callQueue, 'userDid[0].did')) + " ")])]) : _vm._e()]) : _vm._e(), _c('vb-icon', {
      staticClass: "rightFacingArrow",
      attrs: {
        "icon": "rightFacingArrow-IOSIcon",
        "width": "16.642",
        "height": "15.275"
      }
    })], 1)]);
  }), 0)], 2), _c('EditCallQueueModal', {
    on: {
      "list-update": function ($event) {
        return _vm.afterAdding();
      }
    }
  }), _c('AddCallQueueModal', {
    on: {
      "call-queue-added": function ($event) {
        return _vm.afterAdding();
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }